import React from 'react';
import {AnimatePresence, motion} from "framer-motion";
import {useTranslation} from "react-i18next";

// Overlay incitatif : proposer de jouer le quiz pour booster son score (depuis le leaderboard)
const QuizBoostOverlay = ({isOpen, onPlay, onClose}) => {
    const {t} = useTranslation();

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-4"
                    initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}
                >
                    <div className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm" onClick={onClose}/>

                    <motion.div
                        initial={{y: 60, opacity: 0, scale: 0.96}}
                        animate={{y: 0, opacity: 1, scale: 1}}
                        exit={{y: 40, opacity: 0}}
                        transition={{type: 'spring', damping: 22, stiffness: 260}}
                        className="relative z-10 w-full max-w-sm bg-brand-dark rounded-3xl p-7 overflow-hidden shadow-2xl"
                    >
                        {/* Halo */}
                        <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-64 rounded-full bg-action-green/20 blur-[70px] pointer-events-none"/>
                        <div className="absolute -bottom-10 -right-10 w-40 h-40 rounded-full bg-yellow-400/10 blur-[60px] pointer-events-none"/>

                        <div className="relative z-10 text-center">
                            <motion.div
                                animate={{rotate: [0, -12, 12, 0], scale: [1, 1.12, 1]}}
                                transition={{repeat: Infinity, duration: 2.4, ease: 'easeInOut'}}
                                className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-action-green/15 border border-action-green/30 flex items-center justify-center text-3xl"
                            >
                                ⚡
                            </motion.div>

                            <h3 className="text-2xl font-black text-white uppercase tracking-tight leading-none mb-3">
                                {t('leaderboard.quiz_boost.title', 'Booste ton score !')}
                            </h3>
                            <p className="text-sm text-gray-400 font-medium leading-relaxed mb-6">
                                {t('leaderboard.quiz_boost.subtitle', 'Joue le quiz du jour et ajoute des points à ton prono pour grimper au classement.')}
                            </p>

                            <button
                                onClick={onPlay}
                                className="w-full py-4 bg-action-green text-white font-black text-base uppercase tracking-widest rounded-xl shadow-[0_10px_30px_-10px_rgba(16,185,129,0.6)] hover:scale-[1.02] active:scale-95 transition-all"
                            >
                                {t('leaderboard.quiz_boost.cta', 'Jouer le quiz')}
                            </button>
                            <button
                                onClick={onClose}
                                className="w-full mt-3 py-2 text-xs font-bold text-gray-500 uppercase tracking-widest hover:text-gray-300 transition-colors"
                            >
                                {t('leaderboard.quiz_boost.later', 'Plus tard')}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default QuizBoostOverlay;
